import { DELETE_DMX_DEVICE_PRESET, DELETE_DMX_DEVICE_PRESET_SUCCESSFUL, DELETE_DMX_DEVICE_PRESET_FAILED } from './actionTypes';

const initialState = {
  deleteDmxDevicePresetError: null,
  messageDmxDevicePreset: null,
  loadingDeleteDmxDevicePreset: false,
};

const deleteDevicePreset = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_DMX_DEVICE_PRESET:
      state = { ...state, loadingDeleteDmxDevicePreset: true, deleteDmxDevicePresetError: null };
      break;
    case DELETE_DMX_DEVICE_PRESET_SUCCESSFUL:
      state = { ...state, loadingDeleteDmxDevicePreset: false, messageDmxDevicePreset: action.payload, deleteDmxDevicePresetError: null };
      break;
    case DELETE_DMX_DEVICE_PRESET_FAILED:
      state = { ...state, messageDmxDevicePreset: null, loadingDeleteDmxDevicePreset: false, deleteDmxDevicePresetError: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default deleteDevicePreset;
